import { render, staticRenderFns } from "./pkqUserWrong.vue?vue&type=template&id=24801199&scoped=true"
import script from "./pkqUserWrong.vue?vue&type=script&lang=js"
export * from "./pkqUserWrong.vue?vue&type=script&lang=js"
import style0 from "./pkqUserWrong.vue?vue&type=style&index=0&id=24801199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24801199",
  null
  
)

export default component.exports